<template>
    <div id="app">
        <loading v-if="$auth && !$auth.ready()" :branding="true" :overlay="true"></loading>
        <home-page :previewMessageId="previewMessageId" v-if="!$auth || $auth.ready() && $auth.check()"></home-page>
    </div>
</template>

<script>
    import Vue from 'vue';

    import HomePage from '@/components/home-page';

    Vue.component('home-page', HomePage);

    export default {
        data() {
            return {
                dnb: {
                    type: Number
                },
                key: {
                    type: String
                },
                previewMessageId: {

                },
                heartbeatCheckInterval: null,
                heartbeatLastReceived: null
            }
        },
        methods: {
            refresh: function () {
                //window.location.href = window.location + (!authRequired ? "" : "?dnb=" + this.dnb + "&key=" + this.key);
            },
            refreshPage: function () {
                console.log("recieved refresh command")
                setTimeout(this.refresh, 1000);
            },
            handleSignalrHeartbeat: function () {
                console.log("recieved signalr heartbeat");
                this.heartbeatLastReceived = Date.now();
            },
            checkHeartbeatInterval: function () {
                console.log("checking signalr heartbeat")

                const TWENTY_SECONDS = 1000 * 20;
                const fiveSecondsAgo = Date.now() - TWENTY_SECONDS;

                if (this.heartbeatLastReceived > fiveSecondsAgo) {
                    return;
                }
                console.log("checking signalr heartbeat - needs refresh")
                this.refresh();
            },
            signalRStart: function () {
                console.log("!!!");
                console.log("signalRStart: Call RegisterInterestedNoticeBoard: " + parseInt(!authRequired ? 1 : this.dnb));

                this.$noticeBoardHub.on('forceRefresh', this.refreshPage);
                this.$noticeBoardHub.on('signalrHeartbeat', this.handleSignalrHeartbeat);

                this.$noticeBoardHub.invoke('RegisterInterestedNoticeBoard', parseInt(!authRequired ? 1 : this.dnb));

                if (window.expectSignalrHeartbeat) {
                    this.heartbeatCheckInterval = setInterval(this.checkHeartbeatInterval, 10000);
                }
            }
        },

        async created() {
            if (authRequired) {
                this.previewMessageId = getUrlParameter("messageId");
                this.dnb = getUrlParameter("dnb");
                this.key = getUrlParameter("key");
                this.$auth.login({
                    data: {
                        username: "dnr::" + this.dnb,
                        password: this.key
                    }, // Axios
                    rememberMe: false,
                    redirect: { name: 'home' },
                    fetchUser: false,
                    error: null,
                });
            } else {
                this.previewMessageId = null;
            }

        },
        mounted() {
            console.log('main app mounted');

            this.$noticeBoardHubStartRegistration(this.signalRStart.bind(this));
            

            console.log("###");

            console.log('main app mounted finished');

        },
    }
    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }
</script>

<style>

    * {
        box-sizing: border-box;
    }

    #app {
        height: 100%;
    }

    .app-night-mode {
        background-color: #333;
        color: #fff;
        height: 100%;
    }

    html, body {
        height: 100%;
        font-family: 'Ubuntu', sans-serif;
        margin:0;
    }
</style>
